import {makeAutoObservable} from "mobx";
//import history from '../authentication/History';
import environment from '../environments';
import {apiFetch, notifyError} from '../api';

class StatStore
{

    stats = [];
    top10ScannedStickers = []

    /* Endpoints */
    dataEndpoint = environment.API_HOST + "/stats/global";

    constructor()
    {
        makeAutoObservable(this)
    }

    getGlobalStats()
    {
        apiFetch(this.dataEndpoint)
            .then((json) =>
            {
                this.stats = json.data;
            })
            .catch((error) =>
            {
                notifyError(error);
                return error;
            })
    }
}

const statStore = new StatStore();
export default statStore;
